import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getReviewAndSummaryAsync,
  getPCBDetailsAsync,
  pcbTopBottomLayerData,
  getPreviousPCBDetails,
} from 'src/redux/async/pcb/pcb.async'

const initialState = {
  defaultCurrency: '$',
  currencyExchangeValue: 1,

  reviewAndSummaryLoader: false,
  reviewAndSummaryError: '',
  reviewAndSummaryData: [],
  reviewAndSummaryWaterfallData: [],
  reviewAndSummaryKpiData: {},
  pcbDetailsLoader: false,
  pcbDetailsError: '',
  pcbDetailsData: {},
  topBottomLayerDataLoader: false,
  topBottomLayerDataError: '',
  topBottomLayerData: {},
  previousPCBDataLoader: false,
  previousPCBDataError: '',
  previousPCBData: {},
}

export const pcbSlice = createSlice({
  name: 'pcb-dev',
  initialState,
  extraReducers: (builder) => {
    // Review and Summary details
    builder.addMatcher(isAnyOf(getReviewAndSummaryAsync.pending), (state) => {
      state.reviewAndSummaryLoader = true
      state.reviewAndSummaryData = []
      state.reviewAndSummaryKpiData = {}
      state.reviewAndSummaryWaterfallData = []
    })
    builder.addMatcher(isAnyOf(getReviewAndSummaryAsync.fulfilled), (state, action) => {
      state.reviewAndSummaryLoader = false
      state.reviewAndSummaryData = action.payload?.data ?? []
      state.reviewAndSummaryKpiData = action.payload?.kpi ?? {}
      state.reviewAndSummaryWaterfallData = action.payload?.should_cost_builder ?? []
      state.reviewAndSummaryError = ''
    })
    builder.addMatcher(isAnyOf(getReviewAndSummaryAsync.rejected), (state, action) => {
      state.reviewAndSummaryLoader = false
      state.reviewAndSummaryError = action.payload
    })
    // PCB details
    builder.addMatcher(isAnyOf(getPCBDetailsAsync.pending), (state) => {
      state.pcbDetailsLoader = true
      state.pcbDetailsData = {}
    })
    builder.addMatcher(isAnyOf(getPCBDetailsAsync.fulfilled), (state, action) => {
      state.pcbDetailsLoader = false
      state.pcbDetailsData = action.payload.data
      state.pcbDetailsError = ''
    })
    builder.addMatcher(isAnyOf(getPCBDetailsAsync.rejected), (state, action) => {
      state.pcbDetailsLoader = false
      state.pcbDetailsError = action.payload
    })
    // Top/Bottom Layer Details
    builder.addMatcher(isAnyOf(pcbTopBottomLayerData.pending), (state) => {
      state.topBottomLayerDataLoader = true
      state.topBottomLayerData = {}
    })
    builder.addMatcher(isAnyOf(pcbTopBottomLayerData.fulfilled), (state, action) => {
      state.topBottomLayerDataLoader = false
      state.topBottomLayerData = action.payload.data
      state.topBottomLayerDataError = ''
    })
    builder.addMatcher(isAnyOf(pcbTopBottomLayerData.rejected), (state, action) => {
      state.topBottomLayerDataLoader = false
      state.topBottomLayerDataError = action.payload
    })
    // Previous PCB data
    builder.addMatcher(isAnyOf(getPreviousPCBDetails.pending), (state) => {
      state.previousPCBDataLoader = true
      state.previousPCBData = {}
    })
    builder.addMatcher(isAnyOf(getPreviousPCBDetails.fulfilled), (state, action) => {
      state.previousPCBDataLoader = false
      state.previousPCBData = action.payload.data
      state.previousPCBDataError = ''
    })
    builder.addMatcher(isAnyOf(getPreviousPCBDetails.rejected), (state, action) => {
      state.previousPCBDataLoader = false
      state.previousPCBDataError = action.payload
    })
  },
  reducers: {
    emptyPreviousPCBDetails: (state) => {
      state.previousPCBDataLoader = false
      state.previousPCBDataError = ''
      state.previousPCBData = {}
    },
    emptyReviewAndSummaryDetails: (state) => {
      state.reviewAndSummaryLoader = false
      state.reviewAndSummaryError = ''
      state.reviewAndSummaryData = []
      state.reviewAndSummaryWaterfallData = []
      state.reviewAndSummaryKpiData = {}
    },
    setDefaultCurrency: (state, action) => {
      state.defaultCurrency = action.payload
    },
    setCurrencyExchangeValue: (state, action) => {
      state.currencyExchangeValue = action.payload
    },
  },
})

export const {
  emptyPreviousPCBDetails,
  emptyReviewAndSummaryDetails,
  setDefaultCurrency,
  setCurrencyExchangeValue,
} = pcbSlice.actions

export default pcbSlice.reducer
